export default function CsharpStrings() {
  return (
    <h2>Csharp Strings</h2>
  );
}
